import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPipe: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="pipe, super mario, vpn"><path d="M3 20.25H21" stroke="currentColor" strokeWidth="1.5"/><path d="M18.25 10.5V20" stroke="currentColor" strokeWidth="1.5"/><path d="M5.75 20V10.5" stroke="currentColor" strokeWidth="1.5"/><path d="M3.75 3.75H20.25V10.25H3.75V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M7.75 4.25V9.75" stroke="currentColor" strokeWidth="1.5"/><path d="M9.75 10.5V20" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconPipe;
